module.exports = __webpack_public_path__ + "img/Group-36721.af45ad3b.png";